import { get } from 'common';

const BOOK_ROUTE = `${process.env.REACT_APP_API_CONFIG}books`;

export class BookService {
    private static instance: BookService;

    static getInstance(): BookService {
        if (!this.instance) {
            this.instance = new BookService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${BOOK_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${BOOK_ROUTE}/${id}`);
    }
}
